import React from 'react';
import { useGetAllEmailTypes } from '../../../../query/mail';
import Select from 'react-select';
import { useTemplateListingStore } from '../store';

const FilterOptions = ({ innerProps, data }) => {
  return (
    <div
      className="react-select__option"
      style={{ padding: '4px 6px' }}
      {...innerProps}
    >
      <p className="text-ellipsis" style={{ marginBottom: 0, fontSize: 12 }}>
        {data.type}
      </p>
    </div>
  );
};

export default function EmailTypeFiltering() {
  const { data, isLoading } = useGetAllEmailTypes();
  const { emailTypeId, setEmailTypeId } = useTemplateListingStore();
  const defaultOption = {
    label: 'All Email Types',
    type: 'All Email Types',
    value: null,
  };
  return (
    <Select
      classNamePrefix="react-select-small"
      components={{ Option: FilterOptions }}
      filterOption={() => true}
      isClearable={false}
      isLoading={isLoading}
      menuPortalTarget={document.body}
      options={[
        defaultOption,
        ...data.map(e => ({
          ...e,
          label: e.type,
          value: e.id,
        })),
      ]}
      placeholder="Filter by email types..."
      styles={{ fontSize: 10 }}
      value={
        data
          .map(e => ({
            ...e,
            label: e.type,
            value: e.id,
          }))
          .find(e => e.value === emailTypeId) || defaultOption
      }
      onChange={e => setEmailTypeId(e.value)}
    />
  );
}
